/* Travel Diffuser fix (PNM-Advent-v5-2025-09-12) */

(function () {
  'use strict';
  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (!f.matches('form[action*="/cart/add"]')) return;
      if (
        location.pathname.indexOf('/collections/pure-oil-travel-diffusers') !==
        0
      )
        return;
      e.preventDefault();
      e.stopPropagation();
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        body: new FormData(f),
      })
        .then(function (r) {
          return r.ok ? r.json() : Promise.reject();
        })
        .then(function () {
          window.location.href = '/collections/pure-oils?bundle=travel&popup=1';
        })
        .catch(function () {
          try {
            f.submit();
          } catch (_) {
            window.location.href = '/cart';
          }
        });
    },
    true
  );
})();
